import * as React from 'react';
import type { SVGProps } from 'react';
const IconMarketingSolutionsMegaphone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconMarketingSolutionsMegaphone"
    role="presentation"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 1v17.825l-1.57-1.091a21.2 21.2 0 0 0-5.971-2.869l1.788 8.048h-6.05l-2-8.999L3 13.913H2v-8h1c4.347 0 8.58-1.27 12.047-3.563l.382-.259zM5.273 14.028l1.529 6.885h1.951l-1.464-6.586q-.998-.195-2.016-.299M19 13.913l2.598 1.5-1 1.732-2.598-1.5zM15 4.73l-.081.048A23.7 23.7 0 0 1 8 7.394v5.037a23.8 23.8 0 0 1 6.448 2.355l.47.262.081.047zM4.543 7.864l-.528.028L4 7.89v4.043l.543.028q.733.046 1.458.136v-4.37q-.725.09-1.458.136M22 8.913v2h-3v-2zm-1.402-6 1 1.732L19 6.145l-1-1.732z"
      clipRule="evenodd"
    />
  </svg>
);
export default IconMarketingSolutionsMegaphone;
